import React from "react"
import { css, Flex, useTheme } from "@chakra-ui/react"
import colors from "@constants/colors"
import MobileProductList from "./MobileProductList"
import DesktopProductList from "./DesktopProductList"
import { LaptopUpOnly, MobileOnly } from "@utils/MediaQueries"

export type Product = {
  slug: string
  tag?: string
  image: string
  name: string
  model: string
  price: string
  category: string
  variants?: string
}

export interface ProductListProps {
  mobileContainerRef?: any
  desktopContainerRef?: any
  products: Product[]
}

const ProductList: React.FC<ProductListProps> = ({
  mobileContainerRef,
  desktopContainerRef,
  products,
}) => {
  const theme = useTheme()
  const styles = css({
    flexDir: "column",
    fontFamily: "Avenir",
    fontWeight: "500",
    span: {
      color: colors.midAccessible,
    },
    a: {
      color: colors.dark,
    },
  })(theme)

  const hasTags = products.find(({ tag }) => !!tag)

  return (
    <Flex css={styles} w="100%">
      <MobileOnly>
        {products.map((product: Product, idx: number) => (
          <MobileProductList
            containerRef={mobileContainerRef}
            key={`mobile-${idx}-${product.slug}`}
            product={product}
          />
        ))}
      </MobileOnly>
      <LaptopUpOnly>
        {products.map((product: Product, idx: number) => (
          <DesktopProductList
            containerRef={desktopContainerRef}
            key={`desktop-${idx}-${product.slug}`}
            product={product}
            hasTags={hasTags}
          />
        ))}
      </LaptopUpOnly>
    </Flex>
  )
}

export default ProductList
